import React,{Component} from 'react';
import {Toast,ListView} from 'antd-mobile';
import "./style.less"
export default class SecOrderModal extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            dataSource,
        };
      
    }
    componentDidMount() {
        this._init()
    }
    //初始化数据
    _init(){
        this._setDataSource(this.props.data)
    }
    //上啦加载
    _onEndReached=()=>{
        this.props._onEndReached && this.props._onEndReached(this._setDataSource.bind(this));
    };
    //拼接数据
    _setDataSource(dataSource){
        if(!dataSource) return false;
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(dataSource),
        });
    }
     
    render(){       
        const _renderRow = (rowData,index,rowID) => {
            return(
                <div className="searchOrderModal"  key={index} onClick={() => this.props.goPage(rowData)}>
                    <div className="card">
                        <div className="header" >
                            <div className="ordernumer">{rowData.orderNo}</div>
                            <div className="paystate">{rowData.orderType === 0 ? '普通订单' : '改签订单'}</div>
                        </div>
                        <div className="cardbodybox" >
                            <div className="cardbody">
                                <div className="class">{rowData.startName}——{rowData.endName}</div>
                                <div className="num">待出行</div>
                            </div>
                            <div className="carddate">
                                {/*<div className="date">{rowData.orderTime}</div>*/}
                                <div className="seat">{rowData.createTime}</div>
                            </div>
                        </div>
                        <div className="footer">
                            <div className="ordernum">￥{rowData.actualAmount}</div>
                        </div>
                    </div>
                </div>
            )
        }
        return (
            this.props.data == "" ? <div style={{color:"#cccccc",fontSize:"16px",textAlign:"center",paddingTop:"20px"}}>暂无数据</div> :(
                <div className="List">
                    <ListView
                        ref={el => this.lv = el}
                        dataSource={this.state.dataSource}
                        renderFooter={() => (<div style={{ padding:10, textAlign: 'center' }}>
                            {this.props.isLoading ? '数据加载中' : '没有更多'}
                        </div>)}
                        renderRow={_renderRow}
                        // pageSize={4}
                        // useBodyScroll
                        style={{
                            height: '100%',
                            overflow: 'auto',
                        }}
                        scrollRenderAheadDistance={500}
                        onEndReached={this._onEndReached}
                        onEndReachedThreshold={15}
                    />
                </div>
            )

        );
    }
}



// WEBPACK FOOTER //
// ./src/components/SecOrderModal/index.js